import { render, staticRenderFns } from "./RowCollapse.vue?vue&type=template&id=116e48ba&scoped=true"
import script from "./RowCollapse.vue?vue&type=script&lang=js"
export * from "./RowCollapse.vue?vue&type=script&lang=js"
import style0 from "./RowCollapse.vue?vue&type=style&index=0&id=116e48ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116e48ba",
  null
  
)

export default component.exports